import { HelpType } from './HelpModels';
import { LocalStorageSettingsModel } from '../Models/LocalStorageSettingsModel';
import { TextPack } from '../Models/UtilityModels';
import { Utilities } from '../Utility/Utilities';

export class Help {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this; 
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public initialize = (): void => {
        const self = this;

        // Hook up btns
        $('#_layoutHeaderHelpIcon').on('click', function () { $('#helpTextPanel').css('opacity', '1'); $('#helpTextContainer').show(); });
        $('#helpTextCloseBtn').on('click', function () {  $('#helpTextContainer').hide(); });
        $('[name="helpTextShowChk"]').on('click', function () {
            var checked = $(this).is(':checked');
            self.setLocalStorage("AutoShow", checked);
        });

        // Make help draggable
        self.createDragEvents();
        self.createMouseoverEvents();

        // Set auto show check box
        var autoShow = self.getLocalStorage("AutoShow");
        if (autoShow != null) $('[name="helpTextShowChk"]').prop('checked', autoShow);
    }

    public setHelpText = (helpType: HelpType): void => {
        $('#helpTextInnerContainer [name="public"]').hide();
        $('#helpTextInnerContainer [name="reportAnIssue"]').hide();
        $('#helpTextInnerContainer [name="officerMap"]').hide();
        $('#helpTextInnerContainer [name="myTasks"]').hide();
        $('#helpTextInnerContainer [name="taskManagement"]').hide();
        $('#helpTextInnerContainer [name="submissions"]').hide();
        $('#helpTextInnerContainer [name="legal"]').hide();
        $('#helpTextInnerContainer [name="consultations"]').hide();
        $('#helpTextInnerContainer [name="annotations"]').hide();
        $('#helpTextInnerContainer [name="tro"]').hide();

        switch (helpType) {
            case HelpType.Public:
                $('#helpTextContainer [name="public"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "PublicTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "PublicHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Guidance'); 
                });
                break;
            case HelpType.ReportAnIssue:
                $('#helpTextContainer [name="reportAnIssue"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "ReportAnIssueTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "ReportAnIssueHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Report an Issue Guidance');
                });
                break;
            case HelpType.TrustedMap:
                $('#helpTextContainer [name="officerMap"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "OfficerMapTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "OfficerMapHelp" }]).then(m => {
                    if(m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Trusted Map Guidance');
                });
                break;
            case HelpType.MyTasks:
                $('#helpTextContainer [name="myTasks"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "MyTasksTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "MyTasksHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('My Tasks Guidance');
                });
                break;
            case HelpType.TaskManagement:
                $('#helpTextContainer [name="taskManagement"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "TaskManagementTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "TaskManagementHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Task Management Guidance');
                });
                break;
            case HelpType.Submissions:
                $('#helpTextContainer [name="submissions"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "SubmissionsTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "SubmissionsHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('SubmissionsGuidance');
                });
                break;
            case HelpType.Legal:
                $('#helpTextContainer [name="legal"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "LegalEventsTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "LegalEventsHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('LegalGuidance');
                });
                break;
            case HelpType.Consultations:
                $('#helpTextContainer [name="consultations"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "ConsultationsTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "ConsultationsHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Consultation Guidance');
                });
                break;
            case HelpType.Annotations:
                $('#helpTextContainer [name="annotations"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "AnnotationsTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "AnnotationsHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('Annodation Guidance');
                });
                break;
            case HelpType.TRO:
                $('#helpTextContainer [name="tro"]').show();
                Utilities.GetTranslations([{ textPack: TextPack.HelpTextPack, key: "TROTitleHelp" }, { textPack: TextPack.HelpTextPack, key: "TROHelp" }]).then(m => {
                    if (m.success == true) {
                        $('#helpTextTitle').html(m.data[0].value);
                        $('#helpTextInnerContainer').html(m.data[1].value);
                    }
                    else $('#helpTextTitle').html('TRO Guidance');
                });
                break;
        }  
        if (this.getLocalStorage("AutoShow") != false) $('#helpTextContainer').css("display", "block");
    }

    // ----------------------------------------------------------- //
    // DRAG EVENTS
    private createDragEvents = (): void => {
        var obj = { startPositionX: 0, startPositionY: 0 }; //mouse position
        var scale = 1.0;
        var translate = { x: 0, y: 0 }; //element relative position
        $('#helpTextPanel').on("mousedown", function (e) {
            var move = $('#helpTextPanel');
            obj.startPositionX = e.pageX - translate.x;
            obj.startPositionY = e.pageY - translate.y;
            $(document).on("mousemove", function (e) {
                translate.x = e.pageX - obj.startPositionX;
                translate.y = e.pageY - obj.startPositionY;
                move.css({
                    "transform": "translate(" + translate.x + "px," + translate.y + "px)",
                    "transition": "0s"
                });
            });
        });
        $(document).on("mouseup", function () {
            $(this).off("mousemove");
        });

    }

    private createMouseoverEvents = (): void => {
        $('#helpTextPanel').on("mouseover", function (e) {
            $(this).css('opacity', '1');
        });

        $('#helpTextPanel').on("mouseout", function (e) {
            $(this).css('opacity', '0.7');
        });
    }

    // ----------------------------------------------------------- //
    // LOCALSTORAGE
    private getLocalStorage = (param: string): any => {
        let localStorageSettings_str = window.localStorage.getItem('localStorageSettings');
        if (localStorageSettings_str == null) return;

        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(localStorageSettings_str);
        if (localStorageSettings == null || localStorageSettings.HelpText == null) return;

        return localStorageSettings.HelpText[param];
    }

    private setLocalStorage = (param: string, val: any): void => {
        let localStorageSettings_str = window.localStorage.getItem('localStorageSettings');
        if (localStorageSettings_str == null) return;

        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(localStorageSettings_str);
        if (localStorageSettings == null) return;
        if (localStorageSettings.HelpText == null) localStorageSettings.HelpText = { AutoShow: true, PosX: null, PosY: null };

        localStorageSettings.HelpText[param] = val;
        window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));
        return;
    }
}




